import React, { useState } from "react";
import Text from "../../components/Text";
import { fontSizes } from "../../constants/constants";
import { ReactSVG } from "react-svg";
import icons from "../../constants/icons";
import ViewReverse from "../../components/ViewReverse";
import accountClosureFunctional from "./index.function";
import Button from "../../components/Button";
import Divider from "../../components/Divider";
import { Formik } from "formik";
import {
  account_closure_schema,
  account_closure_validation_schema,
} from "../../validations_schemas/account_closure_schema";
import ErrorText from "../../components/ErrorText";
import CustomTextArea from "../../components/CustomTextArea";
import CustomCheckbox from "../../components/CustomCheckbox";

const AccountClosure = () => {
  const {
    TextWeight,
    getContentKey,
    navigate,
    isArabic,
    onSubmit,
    settingLoading,
  } = accountClosureFunctional();

  return (
    <div className="min-h-full">
      <ViewReverse className="gap-5 items-center">
        <ReactSVG
          src={icons?.backSmall}
          className={`cursor-pointer ${isArabic ? "rotate-180" : ""}`}
          onClick={() => navigate(-1)}
        />
        <Text
          text={getContentKey("account_closure_heading")}
          color="text-black"
          size={fontSizes.h18}
          weight={TextWeight.bold}
        />
      </ViewReverse>
      <div className="mt-4">
        <Formik
          initialValues={account_closure_schema}
          validationSchema={account_closure_validation_schema}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values, functions) =>
            onSubmit(values, functions?.resetForm)
          }
        >
          {({
            handleSubmit,
            setFieldValue,
            setFieldError,
            values,
            errors,
            resetForm,
          }) => {
            const is_valid = values?.reasonClosure && values?.is_authorized;

            return (
              <>
                <ViewReverse>
                  <div className="w-full pt-2 sm:pt-4">
                    <CustomTextArea
                      label={getContentKey("reason_closure")}
                      placeholder={getContentKey("enter_reason_placeholder")}
                      isRounded
                      isRequired
                      rows={3}
                      value={values?.reasonClosure}
                      onChange={(e) => {
                        setFieldValue("reasonClosure", e?.target?.value);
                        setFieldError("reasonClosure", null);
                      }}
                      isError={errors?.reasonClosure}
                    />
                  </div>
                </ViewReverse>
                <ErrorText text={getContentKey(errors?.reasonClosure)} />

                <ViewReverse className="pb-3 mt-3 gap-2" onClick={() => setFieldValue('is_authorized', !values?.is_authorized)}>
                  <CustomCheckbox isChecked={values?.is_authorized} />
                  <Text
                    text={
                      <>
                        <span>{getContentKey("authorize")}</span>
                        {/* <Text
                          text={getContentKey("tharwat")}
                          // onClick={() => navigate('/')}
                          className="inline cursor-pointer mx-1"
                          color="text-primary"
                          size={fontSizes.h14}
                        />
                        <span>{getContentKey("close_my_account")}</span> */}
                      </>
                    }
                    weight={TextWeight.regular}
                    isTruncate={false}
                    size={fontSizes.h14}
                    color="text-black"
                    className="inline"
                  />
                </ViewReverse>
                <Divider className="mt-1 mb-4 bg-grey" />
                <ViewReverse className={"gap-4"}>
                  <Button
                    text={getContentKey("submit_btn")}
                    className={"py-3 h-10 w-44"}
                    isDisabled={!is_valid}
                    onClick={handleSubmit}
                    loading={settingLoading}
                  />
                </ViewReverse>
              </>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AccountClosure;
